import React from 'react';
import { Link } from 'react-scroll';

const Home = () => {
  return (
    <div className="home">
      <h2 className="greetings">
        Hi There 👋, I'm Kibe Maina, <br /> a Front-End software engineer
      </h2>
      <p>
        Please take a look around, see what I've been up to, and let's see what
        we can build together.
      </p>
      <ul>
        <li>
          <Link to="pitch" spy={true} smooth={true}>
            I need a site
          </Link>
        </li>
      </ul>

    </div>
  );
};

export default Home;
